export default "__VITE_ASSET__BiyokEfW__"